module.exports = __webpack_public_path__ + "img/circles-behind-cv-image.963f2d95.svg";